import React, { memo } from 'react';
import { Checkbox } from '../Checkbox';
import { type TableCheckboxProps } from './DataTable.types';

const TableCheckbox: React.FC<TableCheckboxProps> = memo((props) => {
  const { checked, colorMode, data, name, onChange, disabled, tooltip } = props;

  // eslint-disable-next-line
  // @ts-ignore
  const changeHandler = ({ value }) => {
    onChange({ data, value });
  };

  return (
    <Checkbox
      checked={checked}
      colorMode={colorMode}
      name={name}
      onChange={changeHandler}
      disabled={disabled}
      tooltip={tooltip}
    />
  );
});

TableCheckbox.displayName = 'TableCheckbox';

export default TableCheckbox;
